export const zhTW = {
  // 通用
  common: {
    viewProducts: '查看產品',
    consultNow: '立即諮詢',
    learnMore: '了解更多',
    experienceNow: '立即體驗',
    buyNow: '立即購買',
    close: '關閉',
    submit: '提交',
    cancel: '取消',
    back: '返回',
    next: '下一頁',
    previous: '上一頁',
    loading: '加載中...',
    error: '錯誤',
    success: '成功',
    warning: '警告',
    info: '信息'
  },

  messages: {
    common: {
      success: '操作成功',
      error: '發生錯誤，請稍後再試',
      warning: '提示',
      saved: '已儲存',
      updated: '已更新',
      deleted: '已刪除'
    },
    auth: {
      loginSuccess: '登錄成功',
      loginFailed: '登錄失敗',
      registerSuccess: '註冊成功',
      registerFailed: '註冊失敗',
      pleaseLogin: '請先登錄後再操作',
      accountNotActivated: '賬號未激活',
      resendVerificationCode: '重新發送驗證碼',
      verificationCodeSent: '驗證碼已發送，請檢查您的郵箱',
      verificationCodeResent: '驗證碼已重新發送，請檢查您的郵箱',
      sendFailed: '發送失敗',
      emailAlreadyRegistered: '該郵箱可能已註冊。若未完成驗證，是否重新發送驗證碼？',
      resendCode: '重新發送',
      verificationRequired: '驗證碼已發送，請查收郵箱',
      accountNotActivatedInfo: '賬號未激活，已可輸入驗證碼或選擇重發',
      verificationSuccess: '驗證成功，賬號已激活，請登錄',
      verificationFailed: '驗證失敗',
      pleaseEnterEmailAndCode: '請輸入郵箱與驗證碼',
      pleaseEnterEmail: '請輸入郵箱',
      pleaseEnterPassword: '請輸入密碼',
      pleaseEnterName: '請輸入姓名',
      pleaseConfirmPassword: '請確認密碼',
      passwordMismatch: '兩次輸入的密碼不一致',
      pleaseEnterEmailOrPhone: '請填寫郵箱或手機號碼',
      pleaseEnterVerificationCode: '請輸入4位驗證碼',
      verificationCodeLength: '驗證碼為4位數字',
      enterVerificationCode: '請輸入郵箱中的4位驗證碼',
      sendVerificationCode: '發送驗證碼',
      resendVerificationCodeButton: '重發驗證碼',
      completeRegistration: '完成註冊',
      userLoginRegister: '用戶登錄/註冊',
      login: '登錄',
      register: '註冊',
      name: '姓名',
      email: '郵箱',
      password: '密碼',
      confirmPassword: '確認密碼',
      invitationCodeInvalid: '邀請碼無效，請檢查後重新輸入',
      registerSuccessPleaseLogin: '註冊成功！請登錄'
    },
    invitation: {
      myInvitationCode: '我的邀請碼',
      invitationCode: '邀請碼',
      copyInvitationCode: '複製邀請碼',
      invitationCodeCopied: '邀請碼已複製到剪貼板',
      copyFailed: '複製失敗',
      fetchFailed: '獲取邀請碼失敗',
      shareInvitationCode: '分享此邀請碼給朋友，朋友使用此邀請碼註冊後：\n• 朋友首次消費將獲得優惠券\n• 朋友每次消費您都會獲得優惠券',
      close: '關閉',
      invitationCodePlaceholder: '請輸入4位邀請碼（選填）',
      invitationCodeLength: '邀請碼為4位數字',
      inviter: '邀請人',
      inviteFriendsHint: '邀請好友可獲得優惠券'
    },
    orders: {
      loadFailed: '載入訂單失敗',
      loadDetailFailed: '載入訂單詳情失敗',
      cancelConfirmTitle: '確認取消訂單',
      cancelConfirmContent: '確定要取消這個訂單嗎？',
      cancelSuccess: '訂單已取消',
      cancelFailed: '取消訂單失敗',
      cancelNotAllowed: '訂單已發貨，無法取消',
      cancelReason: '用戶主動取消',
      orderNotFound: '訂單信息不存在',
      orderAlreadyCancelled: '訂單已取消',
      searchPlaceholder: '搜索訂單號或地址...',
      filterStatusPlaceholder: '篩選狀態',
      page: {
        title: '訂單管理',
        subtitle: '查看和管理您的所有訂單'
      },
      actions: {
        refresh: '刷新數據',
        reset: '重置',
        view: '查看',
        writeReview: '寫評論',
        shareExperience: '分享體驗'
      },
      list: {
        title: '訂單列表',
        summary: '共 {count} 筆訂單',
        empty: '暫無訂單數據'
      },
      socialShare: {
        submitSuccess: '分享記錄提交成功！審核通過後將發放專屬優惠券',
        submitFailed: '提交失敗，請重試',
        platformLabel: '社交媒體平台',
        platformRequired: '請選擇社交媒體平台',
        platformPlaceholder: '請選擇您分享的平台',
        linkLabel: '分享鏈接',
        linkRequired: '請輸入分享鏈接',
        linkInvalid: '請輸入有效的鏈接地址',
        linkPlaceholder: '請粘貼您的分享鏈接，如：https://...',
        descriptionLabel: '分享描述（可選）',
        descriptionPlaceholder: '請簡單描述您的使用體驗，這將幫助我們更好地審核...',
        status: {
          pending: '待審核',
          approved: '已通過',
          couponSent: '已發券',
          rejected: '已拒絕'
        }
      },
      review: {
        title: '寫商品評論',
        congratulations: '🎉 恭喜您成功收貨！',
        helpOthers: '現在為您的商品寫評價，幫助其他用戶了解產品！',
        updateHint: '提示：如果您已經評價過該商品，提交新評價將覆蓋之前的評價',
        reviewUpdated: '評價已更新，等待審核',
        loadedExisting: '已加載您之前的評價，可以修改後重新提交',
        progressInfo: '📦 您的訂單有 {total} 個商品，當前評價第 {current} 個',
        reviewed: '已評價',
        current: '當前',
        notReviewed: '未評價',
        reviewedCount: '已評價 {reviewed} / {total}',
        currentProduct: '📝 當前評價商品：',
        product: '商品',
        noProducts: '訂單沒有商品，無法提交評價',
        productNotFound: '商品信息不存在',
        invalidOrderId: '訂單ID無效，無法提交評價',
        invalidProductId: '商品ID無效',
        ratingRequired: '請選擇評分',
        noUserInfo: '無法獲取用戶信息，請重新登錄',
        submitSuccess: '評價提交成功',
        submitSuccessWithCount: '成功提交 {count} 條評價，等待審核',
        submitFailed: '評價提交失敗，請重試',
        switchedToNext: '已切換到第 {next} 個商品',
        allReviewsCompleted: '所有商品評價已完成！',
        skippedToNext: '已跳過，切換到第 {next} 個商品',
        allCompleted: '已完成所有商品的瀏覽！',
        previousProduct: '上一個商品',
        skipProduct: '跳過此商品',
        reviewLater: '稍後評價',
        submitReview: '提交評價',
        ratingLabel: '評分',
        titleLabel: '評價標題',
        titlePlaceholder: '給您的評價起個標題（可選）',
        contentLabel: '評價內容',
        contentRequired: '請輸入評價內容',
        contentPlaceholder: '請分享您的使用體驗...',
        anonymous: '匿名評價'
      },
      confirmDelivery: {
        title: '確認簽收',
        content: '請確認您已收到商品，確認後將無法撤銷。',
        okText: '確認簽收',
        button: '確認簽收',
        notes: '用戶確認簽收',
        success: '簽收確認成功',
        failed: '簽收確認失敗'
      },
      status: {
        pending: '待處理',
        confirmed: '已確認',
        processing: '處理中',
        shipped: '已發貨',
        delivered: '已送達',
        cancelled: '已取消',
        refunded: '已退款'
      },
      table: {
        orderNumber: '訂單號',
        status: '狀態',
        totalAmount: '總金額',
        itemCount: '商品數量',
        shippingAddress: '收貨地址',
        createdAt: '創建時間',
        actions: '操作',
        view: '查看',
        cancelOrder: '取消訂單'
      },
      details: {
        orderNumber: '訂單號',
        orderStatus: '訂單狀態',
        totalAmount: '總金額',
        shippingAddress: '收貨地址',
        notes: '備註',
        createdAt: '創建時間',
        updatedAt: '更新時間',
        productList: '商品清單',
        originalPrice: '原价',
        discount: '已優惠',
        total: '總計',
        noData: '無此資料',
        noNotes: '無',
        productId: '商品ID',
        productName: '商品名稱',
        quantity: '數量',
        unitPrice: '單價',
        subtotal: '小計'
      },
      shipping: {
        title: '發貨信息',
        loading: '正在加載發貨信息...',
        trackingNumber: '運單號',
        carrier: '承運商',
        status: '發貨狀態',
        shippedAt: '發貨時間',
        deliveredAt: '送達時間',
        deliveryAddress: '收貨地址',
        contactPhone: '聯繫電話',
        contactName: '聯繫人',
        shippingNotes: '發貨備註',
        delivered: '已送達',
        inTransit: '運輸中',
        noData: '暫無發貨信息'
      }
    },
    coupon: {
      title: '優惠券選擇',
      loginRequired: '請先登錄',
      noAvailable: '暫無可用優惠券',
      fetchFailed: '獲取優惠券失敗',
      stackable: '可疊加',
      noDescription: '無描述',
      daysLeft: '剩餘 {{days}} 天',
      selectedCount: '已選擇 {{count}} 張優惠券，總計優惠：',
      source: {
        referralFirst: '推薦首購',
        referralRegular: '推薦購買',
        adminGrant: '管理員發放',
        systemReward: '系統獎勵',
        registration: '註冊獎勵',
        manual: '手動發放',
        unknown: '未知來源'
      },
      statusAbnormal: '優惠券狀態異常',
      used: '已使用',
      expired: '已過期',
      availableTotal: '可用優惠券總額',
      totalAmount: '累計優惠券總額',
      noData: '暫無優惠券數據',
      earnMethod: '您可以通過推薦好友、系統獎勵等方式獲得優惠券',
      viewedAll: '已查看所有新優惠券',
      notAvailable: '該優惠券不可用，可能已過期或已使用',
      noExpiry: '無期限',
      minimumAmount: '最低消費：{{amount}}',
      minimumAmountNotMet: '訂單金額需滿{{amount}}才能使用此優惠券',
      modal: {
        title: '恭喜！您獲得了新的優惠券',
        progress: '第 {current} / {total} 張',
        defaultDescription: '優惠券',
        sourceLabel: '來源',
        expireLabel: '有效期至',
        next: '下一張',
        done: '知道了',
        remaining: '您還有 {count} 張未查看的優惠券'
      }
    },
    contact: {
      name: '姓名',
      email: '電子郵箱',
      phone: '電話',
      subject: '主題',
      message: '消息內容',
      notProvided: '未提供',
      contactConsultation: '聯繫諮詢',
      form: {
        loginRequired: '請先登錄',
        submitSuccess: '您的留言已發送成功，我們會盡快回復您',
        submitFailed: '發送失敗，請稍後再試',
        messageTemplate: '姓名: {name}\n電子郵箱: {email}\n主題: {subject}\n消息內容: {message}'
      }
    },
    logistics: {
      loadFailed: '載入物流資訊失敗',
      enterTrackingNumber: '請輸入跟蹤號',
      queryFailed: '查詢失敗，請檢查跟蹤號是否正確'
    },
    checkout: {
      cartEmpty: '購物車為空',
      createdSuccess: '訂單創建成功',
      createdFailed: '訂單創建失敗',
      createdSuccessWithInfo: '訂單創建成功！送貨員將在1-3個工作日內聯繫您並安排送貨。',
      createdFailedRetry: '訂單創建失敗，請重試',
      title: '訂單結算',
      shippingInfo: '收貨信息',
      shippingAddress: '收貨地址',
      shippingAddressRequired: '請輸入收貨地址',
      shippingAddressPlaceholder: '請輸入詳細的收貨地址',
      contactPhone: '聯繫電話',
      contactPhoneRequired: '請輸入聯繫電話',
      contactPhonePlaceholder: '請輸入聯繫電話',
      notes: '備註信息',
      notesPlaceholder: '如有特殊要求，請在此備註（選填）',
      subtotal: '商品總價',
      couponDiscount: '優惠券折扣',
      total: '應付金額',
      couponValidationFailed: '優惠券驗證失敗，請重新選擇優惠券',
      paymentMethod: '支付方式',
      cod: '貨到付款',
      deliveryNote: '配送說明',
      deliveryDescription: '送貨員將在1-3個工作日內聯繫您並安排送貨，請保持電話暢通',
      cancel: '取消訂單',
      confirm: '確認下單',
      confirmCancel: '確認取消',
      cancelConfirmation: '您確定要取消訂單嗎？取消後將關閉結算窗口',
      continueOrder: '繼續訂單',
      orderCancelled: '訂單已取消',
      steps: {
        confirmProducts: '確認商品',
        fillInfo: '填寫信息',
        payment: '支付'
      },
      confirmProducts: {
        title: '確認商品',
        quantity: '數量',
        total: '總計',
        nextStep: '下一步'
      },
      fillInfo: {
        title: '填寫收貨信息',
        address: '收貨地址',
        addressPlaceholder: '請輸入詳細的收貨地址',
        addressRequired: '請輸入收貨地址',
        notes: '備註',
        notesPlaceholder: '訂單備註（可選）',
        previousStep: '上一步',
        nextStep: '下一步'
      },
      payment: {
        title: '支付方式',
        orderCreated: '訂單已創建，請選擇支付方式',
        paymentPending: '支付功能待集成',
        payNow: '立即支付'
      }
    },
    config: {
      saveSuccess: '配置保存成功',
      saveFailed: '配置保存失敗',
      reset: '配置已重置',
      validateSuccess: '配置驗證通過',
      validateFailed: '配置驗證失敗'
    },
    address: {
      selectRequired: '請選擇一個收貨地址',
      addSuccess: '收貨地址添加成功',
      updateSuccess: '收貨地址更新成功',
      deleteSuccess: '收貨地址刪除成功',
      setDefaultSuccess: '默認地址設置成功'
    },
    products: {
      loadFailed: '獲取商品數據失敗'
    }
  },

  couponManagement: {
    title: '我的優惠券',
    loginRequired: '請先登錄查看優惠券',
    messages: {
      fetchFailed: '獲取優惠券數據失敗'
    },
    actions: {
      refresh: '刷新'
    },
    stats: {
      activeTotal: '可用優惠券總額',
      totalAmount: '累計優惠券總額',
      expiringSoon: '即將過期優惠券',
      couponUnit: '張'
    },
    list: {
      title: '優惠券列表',
      loading: '載入中...',
      empty: '暫無優惠券'
    },
    status: {
      used: '已使用',
      expired: '已過期',
      expiringSoon: '即將過期',
      available: '可用'
    },
    fields: {
      expiresAt: '過期時間',
      daysLeft: '剩餘 {days} 天',
      usedAt: '使用時間',
      id: 'ID: {id}'
    },
    expiring: {
      title: '即將過期優惠券提醒',
      description: '您有 {count} 張優惠券即將在7天內過期，請及時使用！'
    }
  },

  logistics: {
    title: '物流跟蹤',
    trackByNumber: {
      placeholder: '請輸入跟蹤號',
      button: '查詢'
    },
    list: {
      title: '我的配送',
      searchPlaceholder: '搜索配送資訊...',
      refresh: '刷新',
      trackingNumberLabel: '跟蹤號',
      carrierLabel: '承運商',
      createdAtLabel: '創建時間'
    },
    detail: {
      title: '配送詳情',
      labels: {
        trackingNumber: '跟蹤號',
        carrier: '承運商',
        status: '狀態',
        estimatedDelivery: '預計送達',
        actualDelivery: '實際送達',
        pickupTime: '取件時間',
        notes: '備註'
      },
      values: {
        valueNotSet: '未設置',
        notDelivered: '未送達',
        notPickedUp: '未取件',
        none: '無'
      }
    }
  },

  // 导航
  nav: {
    brand: '納舒純™',
    home: '首頁',
    about: '關於我們',
    products: '產品介紹',
    usage: '使用方式',
    classroom: '納舒純小課堂',
    symptoms: '症狀科普',
    shoppingGuide: '購物說明',
    contact: '聯絡我們',
    login: '登錄',
    myAccount: '我的賬戶',
    productCatalog: '產品目錄',
    myOrders: '我的訂單',
    myCoupons: '我的優惠券',
    logisticsTracking: '物流跟蹤',
    customerService: '客服中心',
    logout: '退出登錄',
    shoppingCart: '購物車',
    myInvitationCode: '我的邀請碼'
  },

  // 购物车
  cart: {
    title: '',
    empty: '購物車為空',
    removeItem: '商品已從購物車中移除',
    clearCart: '購物車已清空',
    checkout: '結算',
    total: '總計',
    quantity: '數量',
    remove: '移除',
    clear: '清空購物車',
    continueShopping: '繼續購物',
    stock: '庫存',
    subtotal: '小計',
    useCoupon: '使用優惠券',
    selectItemsWarning: '請選擇要購買的商品',
    orderCreatedSuccess: '訂單創建成功！',
    selectAll: '全選',
    selectedItems: '已選擇 {selected} / {total} 件商品',
    selectedTotalPrice: '選中商品總價',
    couponDiscount: '優惠券折扣',
    payableAmount: '應付金額',
    items: '件',
    discounted: '已優惠',
    addToCartSuccess: '已添加到購物車'
  },

  // 首页
  home: {
    hero: {
      title: '自由呼吸帶來美麗心情',
      slogan: '鼻炎多洗洗，健康好身體\n自由去呼吸，快樂做自己',
      description1: '專業洗鼻技術，溫和清潔鼻腔，讓您享受順暢呼吸的每一天',
      description2: '科學護理理念，喚醒鼻腔天然防護力，呵護您的呼吸道健康',
      viewProducts: '立即體驗',
      consultNow: '專業諮詢'
    },
        carousel: {
          slide1: {
            title: '納舒純洗鼻器\n您的鼻腔健康守護衛士',
            description: '專注於柔性正負壓平衡洗鼻器，讓洗鼻更簡單、更舒服、更放心',
            buttonText: '立即體驗'
          },
          slide2: {
            title: '鼻子的健康，您交給納舒純就對了',
            description: '專注於洗鼻器多年，讓鼻腔的壓抑暢通無阻',
            buttonText: '了解更多'
          },
          slide3: {
            title: '柔性更舒服/正負平衡更安全/告別洗鼻難受',
            description: '專業洗鼻技術，為您提供舒適安全的鼻腔護理體驗',
            buttonText: '點擊購買'
          }
        },
    sections: {
      nasalHealth: {
        title: '人離不開氧氣',
        description: '人體每分鐘需要吸入約6-8升空氣，其中氧氣是維持生命活動最重要的元素。鼻腔作為呼吸系統的第一道關卡，其健康狀況直接影響我們的吸氧效率。',
        features: [
          '鼻腔暢通，氧氣供應充足，精神更飽滿',
          '鼻塞時吸氧量驟減，容易疲勞、注意力不集中',
          '長期呼吸不順，影響睡眠品質和工作效率',
          '定期護理鼻腔，讓每一次呼吸都充滿活力'
        ]
      },
      nasalCare: {
        title: '讓洗鼻成為您健康的護養伙伴！',
        description: '許多鼻腔問題的根源，在於鼻腔長期承受超過負荷的刺激與負擔。\n當我們在日常中主動淨化鼻腔，洗去累積的致病源與刺激物，就能幫助鼻腔減輕負荷、回歸原有的平衡狀態。\n洗鼻，不只是清潔，更是喚醒鼻腔自癒力的溫柔儀式。透過溫和的沖洗，我們讓鼻腔黏膜恢復防禦機能，強化對外界污染的緩衝力，找回呼吸道的穩定與健康。\n我們深信：真正的保養，是順應身體原有的智慧，讓它自然發揮該有的保護力。\n而藥物，不一定是應對鼻部困擾的唯一選擇。\n讓「洗鼻」成為你健康的護養伙伴，陪伴你在每一天，溫柔守護呼吸的純淨與自由。',
        learnMore: '了解更多鼻腔護理知識→'
      },
      lifestyle: {
        title: '洗鼻：現代人的呼吸新革命',
        description: '如同刷牙、洗臉一樣自然，洗鼻已成為現代人不可或缺的健康習慣。每天幾分鐘的鼻腔護理，不僅預防疾病，更讓您享受清新呼吸的美好。',
        features: [
          { title: '預防呼吸道疾病', desc: '清除過敏原，減少感染風險' },
          { title: '改善睡眠品質', desc: '呼吸順暢，一夜好眠' },
          { title: '提升精神狀態', desc: '充足氧氣，思維更清晰' },
          { title: '增強免疫力', desc: '健康防護，身體更強健' }
        ],
        learnMore: '深入了解',
        experienceNow: '開始體驗'
      },
      analysis: {
        title: '為什麼很多人不敢洗鼻？',
        description: '儘管人們知道洗鼻有益健康，但對傳統洗鼻方式充滿畏懼和擔憂，選擇放棄。害怕感染、疼痛和操作困難，這些是阻礙人們開始洗鼻的主要障礙。',
        stats: [
          { number: '75%', label: '害怕嗆水' },
          { number: '68%', label: '擔心疼痛' },
          { number: '42%', label: '覺得麻煩' },
          { number: '70%', label: '擔心中耳炎' }
        ]
      },
      whyChoose: {
        title: '選擇納舒純™，選擇更好的呼吸',
        subtitle: '突破傳統限制，重新定義鼻腔護理體驗',
        features: [
          { title: '創新平衡壓力技術', desc: '專利設計，告別嗆水困擾，溫和舒適如按摩般享受', badge: '獨家專利' },
          { title: '醫療級洗鼻頭', desc: '精密製造，深度清潔，讓每一次護理都更有效', badge: '醫療認證' },
          { title: '安全品質保證', desc: '國際認證，安心使用，為您的健康保駕護航', badge: '國際認證' }
        ],
        buttons: {
          buyNow: '立即購買'
        }
      },
      userTestimonials: {
        title: '用戶見證'
      },
      products: {
        title: '納舒純暢銷商品',
        subtitle: '精選優質產品，為您的鼻腔健康保駕護航',
        buttons: {
          buyNow: '立即購買'
        },
        badges: {
          hot: '熱銷',
          new: '新品',
          essential: '必備',
          accessory: '配件'
        },
        items: {
          gen1: {
            name: '納舒純一代洗鼻器',
            alt: '納舒純一代洗鼻器'
          },
          gen2: {
            name: '納舒純二代洗鼻器',
            alt: '納舒純二代洗鼻器'
          },
          salt: {
            name: '納舒純洗鼻鹽',
            alt: '納舒純洗鼻鹽'
          },
          tip: {
            name: '納舒純治療級洗鼻頭',
            alt: '納舒純治療級洗鼻頭'
          }
        }
      },
      services: {
        title: '我們的服務承諾',
        subtitle: '為您提供最優質的產品和服務體驗',
        items: {
          shipping: {
            title: '24h 快速出貨',
            description: '全年無休，最快隔日到貨'
          },
          freeShipping: {
            title: '滿 $500 免運',
            description: '全館滿額免運'
          },
          quality: {
            title: '安心品質保證',
            description: 'SGS/QMS/RoHS三重認證'
          }
        }
      },
      video: {
        text: '觀看產品介紹影片',
        note: '了解納舒純洗鼻器的使用方法'
      },
      images: {
        nasalHealth: '鼻腔健康圖片',
        nasalCare: '鼻腔護理圖片',
        lifestyle: '生活方式圖片',
        analysis: '現狀分析圖片',
        user: '用戶頭像'
      }
    },
    stats: {
      satisfied: '滿意用戶',
      satisfiedDesc: '滿意用戶',
      recommendation: '推薦率',
      recommendationDesc: '推薦率',
      rating: '用戶評分',
      ratingDesc: '用戶評分',
      support: '客服支援',
      supportDesc: '全天服務'
    }
  },

  // 健康教室
  classroom: {
    title: '納舒純健康學堂',
    subtitle: '科學洗鼻，健康呼吸每一天',
    description: '專業鼻腔健康知識分享，助您掌握正確的洗鼻方法',
    sectionTitle: '鼻腔健康',
    readMore: '閱讀全文',
    backToList: '返回文章列表',
    articles: {
      covid: {
        title: '新冠防疫新利器：科學洗鼻法',
        badge: '防疫新知',
        subtitle: '國際研究證實，科學洗鼻可有效降低感染風險，是防疫的重要輔助手段！',
        content: `
          <p class="lead">新冠病毒主要通過呼吸道傳播，鼻腔是病毒進入人體的重要門戶。科學的洗鼻方法可以有效清除鼻腔內的病毒，降低感染風險，是新冠防疫的重要輔助措施。</p>
          
          <h2>新冠病毒與鼻腔的關係</h2>
          <p>新冠病毒主要通過ACE2受體進入人體細胞，而鼻腔黏膜上富含ACE2受體，是病毒的主要感染部位。病毒在鼻腔內複製後，會通過呼吸道向下傳播，導致全身感染。</p>
          
          <div class="highlight-box">
            <h4>重要提醒</h4>
            <p class="mb-0">洗鼻是新冠防疫的輔助方法，不能替代疫苗接種、戴口罩、保持社交距離等主要防疫措施。</p>
          </div>
          
          <h2>洗鼻對新冠防疫的作用機制</h2>
          <h3>1. 物理清除病毒</h3>
          <p>洗鼻通過物理沖洗的方式，可以有效清除附著在鼻腔黏膜上的病毒顆粒，減少病毒載量，降低感染風險。</p>
          
          <h3>2. 稀釋病毒濃度</h3>
          <p>生理鹽水沖洗可以稀釋鼻腔內的病毒濃度，降低病毒對黏膜的附著能力，減少感染機會。</p>
          
          <h3>3. 增強黏膜防護</h3>
          <p>規律洗鼻可以保持鼻腔濕潤，增強黏膜的自我防護能力，提高對病毒的抵抗力。</p>
          
          <h2>科學研究證據</h2>
          <p>多項國際研究顯示，鼻腔沖洗對新冠病毒具有顯著的防護和治療效果：</p>
          <ul>
            <li>英國研究發現，鼻腔沖洗可將新冠感染風險降低62%</li>
            <li>美國研究證實，洗鼻可縮短新冠病程2-3天</li>
            <li>德國研究顯示，洗鼻可減少重症率40%</li>
          </ul>
          
          <h2>正確的洗鼻方法</h2>
          <h3>1. 選擇合適的洗鼻器</h3>
          <p>推薦使用負壓式洗鼻器，如納舒純洗鼻器，安全溫和，適合日常使用。</p>
          
          <h3>2. 配製生理鹽水</h3>
          <p>使用0.9%的生理鹽水，溫度控制在35-37°C，接近體溫。</p>
          
          <h3>3. 正確的洗鼻姿勢</h3>
          <p>頭部前傾45度，將洗鼻頭輕輕插入一側鼻孔，讓鹽水從另一側鼻孔流出。</p>
          
          <h3>4. 洗鼻頻率</h3>
          <p>建議每天洗鼻1-2次，每次5-10分鐘，持續使用效果更佳。</p>
          
          <h2>注意事項</h2>
          <ul>
            <li>洗鼻前後要徹底清潔雙手</li>
            <li>使用專用的洗鼻鹽，避免使用普通食鹽</li>
            <li>洗鼻後要徹底清潔洗鼻器</li>
            <li>如有不適，應立即停止並諮詢醫生</li>
          </ul>
          
          <h2>結語</h2>
          <p>洗鼻作為新冠防疫的輔助方法，具有安全、有效、經濟的特點。通過科學的洗鼻方法，配合其他防疫措施，可以有效降低感染風險，保護自己和家人的健康。</p>
        `
      },
      cold: {
        title: '感冒救星：洗鼻緩解鼻塞不適',
        badge: '感冒護理',
        subtitle: '感冒鼻塞困擾？科學洗鼻是快速緩解症狀的天然有效方法！',
        content: '<p class="lead">感冒是生活中最常見的疾病之一，鼻塞、流鼻涕等症狀嚴重影響生活質量。洗鼻作為一種天然、安全、有效的輔助療法，正受到越來越多人的關注。</p><h2>感冒洗鼻的科學原理</h2><p>感冒時病毒會刺激鼻腔黏膜，導致鼻腔分泌物增多，引起鼻塞、流鼻涕等症狀。洗鼻通過物理沖洗的方式，能夠：</p><ul><li>清除病毒和細菌</li><li>減少鼻塞和炎症</li><li>緩解症狀，加速康復</li></ul><h2>結語</h2><p>洗鼻作為感冒治療的輔助方法，具有安全、有效、經濟的特點。通過科學的洗鼻方法，配合其他治療措施，可以有效緩解感冒症狀，加速康復。</p>'
      },
      rhinitis: {
        title: '鼻炎剋星：科學洗鼻改善鼻腔健康',
        badge: '鼻炎護理',
        subtitle: '慢性鼻炎反覆發作？科學洗鼻是改善鼻腔健康的重要方法！',
        content: '<p class="lead">慢性鼻炎困擾您的生活嗎？洗鼻是治療鼻炎的重要輔助方法！本文詳細介紹洗鼻對各種類型鼻炎的治療效果，讓您重獲暢通呼吸。</p><h2>鼻炎的分類與症狀</h2><p>鼻炎主要分為過敏性鼻炎、感染性鼻炎和血管運動性鼻炎。常見症狀包括鼻塞、流鼻涕、打噴嚏、鼻癢等，嚴重影響生活質量和睡眠質量。</p><h2>結語</h2><p>洗鼻作為鼻炎治療的輔助方法，具有安全、有效、經濟的特點。通過科學的洗鼻方法，配合其他治療措施，可以有效改善鼻炎症狀，提高生活質量。</p>'
      },
      allergicRhinitis: {
        title: '過敏性鼻炎及症狀：全面解析與治療方案',
        badge: '過敏性鼻炎',
        subtitle: '過敏性鼻炎好難受！台灣每3人就有1人有鼻子過敏問題。',
        content: '<p class="lead">過敏性鼻炎是現代社會最常見的過敏性疾病之一，影響著全球數億人口的生活質量。本文將從病因、症狀、診斷到治療，為您提供全面的過敏性鼻炎指南。</p><h2>什麼是過敏性鼻炎</h2><p>過敏性鼻炎是一種由過敏原引起的鼻腔黏膜炎症性疾病，主要表現為鼻塞、流鼻涕、打噴嚏和鼻癢等症狀。當過敏原進入鼻腔時，會刺激免疫系統產生過敏反應。</p><h2>結語</h2><p>過敏性鼻炎雖然困擾，但通過科學的治療和護理，可以有效控制症狀，提高生活質量。</p>'
      },
      rhinitisSinusitisDifference: {
        title: '鼻炎和鼻竇炎的區別：症狀、治療與預防',
        badge: '疾病區分',
        subtitle: '鼻炎和鼻竇炎常常被混淆，但它們的症狀和治療方法卻大不相同！',
        content: '<p class="lead">鼻炎和鼻竇炎是兩種常見的鼻腔疾病，雖然症狀相似，但病因、治療方法都有所不同。正確區分這兩種疾病，有助於選擇合適的治療方案。</p><h2>鼻炎與鼻竇炎的定義</h2><h3>鼻炎</h3><p>鼻炎是指鼻腔黏膜的炎症，主要影響鼻腔內部，症狀相對較輕。</p><h3>鼻竇炎</h3><p>鼻竇炎是指鼻竇黏膜的炎症，可能引起更嚴重的症狀和併發症。</p><h2>結語</h2><p>正確區分鼻炎和鼻竇炎對於選擇合適的治療方法至關重要。如有疑問，建議及時就醫診斷。</p>'
      },
      rhinitisMedicationGuide: {
        title: '常用鼻炎藥物：種類、作用與注意事項',
        badge: '藥物治療',
        subtitle: '面對琳琅滿目的鼻炎藥物，您知道如何選擇嗎？',
        content: '<p class="lead">藥物治療是鼻炎治療的重要組成部分，正確的用藥方法可以提高療效，減少副作用。本文將介紹常用的鼻炎藥物及其使用方法。</p><h2>常用藥物分類</h2><h3>1. 抗組胺藥</h3><p>抗組胺藥是治療過敏性鼻炎的首選藥物，能夠快速緩解打噴嚏、流鼻涕、鼻癢等症狀。</p><h2>結語</h2><p>藥物治療需要與其他治療方法相結合，在醫生指導下科學用藥，才能達到最佳治療效果。</p>'
      },
      nasalIrrigatorSelectionGuide: {
        title: '洗鼻器的分類選型：如何選擇最適合的洗鼻器',
        badge: '設備選擇',
        subtitle: '市場上洗鼻器種類繁多，正壓、負壓、平衡壓力各有特色！',
        content: '<p class="lead">市場上洗鼻器種類繁多，如何選擇適合自己的洗鼻器？本文將從工作原理、沖洗方式、動力類型等多個維度，為您提供專業的選購建議。</p><h2>洗鼻器的核心分類維度</h2><h3>1. 按工作原理分類</h3><ul><li>正壓式洗鼻器</li><li>負壓式洗鼻器</li><li>平衡壓式洗鼻器</li></ul><h2>結語</h2><p>選擇洗鼻器時，安全性應放在首位。負壓式比正壓式更安全，噴霧式比水柱式更溫和，手動式比電動式更實惠。</p>'
      },
      salineSolutionGuide: {
        title: '洗鼻鹽的選擇：專業配方與市售產品的比較',
        badge: '洗鼻用品',
        subtitle: '洗鼻鹽是洗鼻舒適的關鍵！專業配方、市售產品各有特色',
        content: '<p class="lead">生理鹽水是洗鼻的基礎用品，正確的選擇和使用方法直接影響洗鼻的效果和安全性。本文將詳細介紹生理鹽水的選擇、使用和注意事項。</p><h2>什麼是生理鹽水</h2><p>生理鹽水是指濃度為0.9%的氯化鈉溶液，其滲透壓與人體血漿相同，不會對鼻腔黏膜造成刺激或損傷。</p><h2>結語</h2><p>正確選擇和使用生理鹽水是安全洗鼻的基礎。通過科學的方法，可以確保洗鼻的效果和安全性。</p>'
      },
      allergicRhinitisCare: {
        title: '過敏性鼻炎日常護理指南',
        badge: '日常護理',
        subtitle: '過敏性鼻炎雖然無法完全治癒，但通過正確的日常護理可以有效控制症狀',
        content: '<p class="lead">過敏性鼻炎雖然無法完全治癒，但通過科學的日常護理，可以有效控制症狀，提高生活質量。本文將介紹實用的護理方法。</p><h2>環境控制</h2><h3>1. 室內環境</h3><ul><li>保持室內空氣清潔通風</li><li>使用空氣清淨機過濾過敏原</li><li>定期清潔，減少塵蟎</li></ul><h2>結語</h2><p>過敏性鼻炎的日常護理需要長期堅持，通過綜合措施，可以有效改善症狀，享受更好的生活質量。</p>'
      },
      sinusitisPreventionTreatment: {
        title: '鼻竇炎預防與治療指南',
        badge: '鼻竇炎',
        subtitle: '鼻竇炎是鼻腔周圍骨質空腔的炎症，常見症狀包括鼻塞、頭痛、面部壓痛等',
        content: '<p class="lead">鼻竇炎是一種常見的鼻腔疾病，不僅影響呼吸，還可能引起頭痛等不適。通過科學的預防和治療方法，可以有效控制病情，提高生活質量。</p><h2>鼻竇炎的預防</h2><h3>1. 增強免疫力</h3><p>保持規律作息，適當運動，均衡飲食，增強身體抵抗力，減少感染機會。</p><h2>結語</h2><p>鼻竇炎的預防和治療需要綜合考慮，早期發現、早期治療是關鍵。</p>'
      },
      seasonalRhinitisStrategies: {
        title: '季節性鼻炎應對策略',
        badge: '季節護理',
        subtitle: '季節性鼻炎通常在特定季節發作，如春季花粉季節或秋季草花粉季節',
        content: '<p class="lead">季節性鼻炎是過敏性鼻炎的一種，通常在特定季節發作，如春季花粉季節或秋季草花粉季節。了解季節規律並採取相應措施，可以有效減輕症狀。</p><h2>季節性鼻炎的發作規律</h2><p>不同季節有不同的過敏原：春季主要是樹木花粉，夏季是草花粉，秋季是雜草花粉，冬季則主要是室內過敏原如塵蟎和寵物毛髮。</p><h2>結語</h2><p>季節性鼻炎雖然困擾，但通過了解季節規律和採取相應措施，可以有效控制症狀。記住，預防勝於治療，提前做好準備是關鍵。</p>'
      },
      childrenNasalCareGuide: {
        title: '兒童鼻腔護理指南',
        badge: '兒童護理',
        subtitle: '兒童的鼻腔發育尚未完全成熟，抵抗力相對較弱，容易出現各種鼻腔問題',
        content: '<p class="lead">兒童的鼻腔發育尚未完全成熟，抵抗力相對較弱，容易出現各種鼻腔問題。正確的護理方法不僅能預防疾病，還能促進鼻腔健康發育。</p><h2>兒童鼻腔特點</h2><p>兒童鼻腔相比成人有以下特點：</p><ul><li>鼻腔通道較窄</li><li>黏膜較為敏感</li><li>免疫系統較弱</li></ul><h2>結語</h2><p>兒童鼻腔護理需要特別的關注和細心的照顧，通過科學的方法和家長的監督，可以有效預防疾病，促進鼻腔健康發育。</p>'
      }
    },

    // 分页器显示文本
    pagination: {
      showTotal: '第 {start}-{end} 条，共 {total} 条'
    }
  },

  // 表单
  forms: {
    contact: {
      title: '立即諮詢',
      name: '姓名',
      phone: '電話',
      email: '郵箱',
      company: '公司名稱',
      message: '咨询內容',
      cooperation: '合作意向',
      options: {
        retail: '零售',
        wholesale: '批發',
        odm: '設計製造',
        oem: '代工製造'
      },
      submit: '提交諮詢',
      success: '感謝您的諮詢！我們會盡快與您聯繫。'
    },

    // HomePage 表单
    homeContact: {
      title: '立即諮詢',
      name: {
        label: '姓名',
        placeholder: '請輸入姓名'
      },
      phone: {
        label: '電話',
        placeholder: '請輸入電話'
      },
      email: {
        label: '郵箱',
        placeholder: '請輸入郵箱'
      },
      company: {
        label: '公司名稱',
        placeholder: '請輸入公司名稱'
      },
      message: {
        label: '咨询內容',
        placeholder: '請輸入咨询內容'
      },
      cooperation: {
        label: '合作意向',
        placeholder: '請選擇',
        retail: '零售',
        wholesale: '批發',
        odm: '設計製造',
        oem: '代工製造'
      },
      submit: '提交諮詢',
      success: '感謝您的諮詢！我們會盡快與您聯繫。'
    }
  },



  // 关于我们页面
  about: {
    title: '關於我們',
    subtitle: '專注鼻腔健康，致力於為全球用戶提供最優質的洗鼻護理解決方案',
    businessCooperation: {
      title: '商務合作',
      subtitle: '作為鼻腔護理領域的技術領先者，我們誠摯邀請全球合作夥伴攜手共創未來',
      description: '多種合作模式，共創雙贏局面',
      retail: {
        title: '零售合作',
        subtitle: '品牌推廣',
        features: [
          '線上電商平台',
          '實體門市通路',
          '社群媒體行銷',
          '私人定制服務'
        ]
      },
      wholesale: {
        title: '批發代理',
        subtitle: '區域分銷',
        features: [
          '獨家技術專利',
          '優質產品供應',
          '強勢品牌支持',
          '廣闊市場前景'
        ]
      },
      designManufacturing: {
        title: '設計製造',
        subtitle: '定制開發',
        features: [
          '我們的專利',
          '新外觀',
          '您的品牌',
          '您的市場'
        ]
      },
      oem: {
        title: '代工生產',
        subtitle: '專業製造',
        features: [
          '我們的專利',
          '我們的工廠',
          '我們的品牌',
          '您的市場'
        ]
      }
    },
    certifications: {
      title: '完善的保障資質',
      subtitle: '具有官方認證的產品資質與生產流程資質，並已獲得美國CQC安全認證和歐盟RSL認證。'
    },
    contact: {
      title: '聯絡我們',
      subtitle: '歡迎與我們聯繫，了解更多合作機會和產品信息',
      email: {
        title: '電子郵件',
        address: 'info@ventosano.com',
        response: '24小時內回覆'
      },
      phone: {
        title: '電話聯繫',
        number: '+886 2 1234 5678',
        hours: '週一至週五 9:00-18:00'
      },
      address: {
        title: '公司地址',
        location: '台北市信義區信義路五段7號',
        building: '台北101大樓'
      },
      form: {
        title: '發送訊息',
        name: '姓名',
        namePlaceholder: '您的姓名',
        email: '電子郵件',
        emailPlaceholder: '您的電子郵件',
        subject: '主題',
        subjectPlaceholder: '主題',
        message: '訊息內容',
        messagePlaceholder: '您的訊息',
        submit: '發送訊息'
      }
    },
    experience: {
      title: '專業積澱',
      description: '十年深耕醫療器械領域，在製氧機、洗鼻器、霧化器等產品研發製造方面擁有豐富經驗'
    },
    manufacturing: {
      title: '製造實力',
      description: '擁有8,000+平方米現代化廠房，配備先進生產設備和檢測儀器，嚴格執行醫療器械生產標準'
    },
    innovation: {
      title: '技術創新',
      description: '擁有6項平衡壓力洗鼻器核心專利，持續創新研發，引領行業技術發展'
    },
    team: {
      title: '國際頂尖技術團隊',
      subtitle: '匯聚全球頂尖人才，以新加坡國立大學博士團隊為核心，打造世界級產品',
      singapore: {
        title: '新加坡精密製造專家',
        description: '專精精密製造技術和品質管控，確保產品達到國際最高標準'
      },
      taiwan: {
        title: '台灣流體力學專家',
        description: '專注鼻腔流體力學研究，優化洗鼻水流設計，提升清潔效果'
      },
      india: {
        title: '印度設計工程師',
        description: '負責產品結構設計和3D建模驗證，將創新理念轉化為現實'
      },
      collaboration: '三大國際技術團隊深度協作，為納舒純™產品提供世界級的技術保障和創新動力'
    }
  },


  // Footer
  footer: {
    company: {
      name: '納舒純™',
      description: '專注於鼻腔清潔設備的研發與製造，致力於為用戶提供安全、舒適、有效的鼻腔清潔解決方案。'
    },
    quickLinks: {
      title: '商店訊息',
      features: '特色功能',
      symptoms: '適用症',
      saline: '洗鼻鹽',
      vortex: '漩渦技術'
    },
    services: {
      title: '購物說明',
      cooperation: '合作方式',
      about: '關於我們',
      contact: '聯絡我們'
    },
    contact: {
      title: '聯繫信息',
      email: 'service@ventosano.com',
      phone: '(02) 7730-8767',
      line: 'LINE: @ventosano'
    },
    newsletter: {
      placeholder: '輸入郵箱獲取最新資訊'
    },
    legal: {
      copyright: 'Copyright ©2025 納舒純™. 保留所有權利.',
      privacy: '隱私權聲明',
      deleteAccount: '銷戶申請',
      terms: '政策條款',
      sitemap: '網站地圖'
    }
  },

  // 產品介紹
  products: {
    title: '熱銷商品',
    subtitle: '呵護鼻腔，從簡單開始',
    noProducts: '暫無商品',
    hero: {
      title: '呵護鼻腔，從簡單開始',
      subtitle: '納舒純™ 平衡壓力技術',
      description: '專利技術，安全無憂',
      badge: '獨家專利',
      ctaDescription: '突破傳統洗鼻限制，讓鼻腔護理變得簡單、安全、舒適',
      ctaButton: '了解「五步洗鼻法」'
    },
    comparison: {
      title: '技術革新對比',
      subtitle: '納舒純™ 平衡壓力技術，全面超越傳統洗鼻器',
      features: {
        safety: '安全程度',
        comfort: '使用舒適度',
        effectiveness: '清潔效果',
        cleanliness: '操作便利性',
        price: '性價比'
      },
      levels: {
        low: '較低',
        medium: '中等',
        high: '優秀'
      },
      columns: {
        feature: '對比項目',
        traditionalPositive: '傳統正壓式',
        traditionalNegative: '傳統負壓式',
        nasopureliefa: '納舒純™平衡壓'
      },
      table: {
        rows: [
          {
            feature: '安全性',
            traditionalPositive: '低',
            traditionalNegative: '中',
            nasopureliefa: '高'
          },
          {
            feature: '舒適性',
            traditionalPositive: '低',
            traditionalNegative: '中',
            nasopureliefa: '高'
          },
          {
            feature: '清潔便利性',
            traditionalPositive: '低',
            traditionalNegative: '中',
            nasopureliefa: '高'
          },
          {
            feature: '價格',
            traditionalPositive: '低',
            traditionalNegative: '高',
            nasopureliefa: '中'
          }
        ]
      }
    },
    features: {
      title: '產品特色',
      subtitle: '創新技術，專業品質',
      items: [
        {
          title: '安全',
          description: '正壓洗鼻器容易導致耳內積水中耳炎；純負壓洗鼻器可能造成毛細血管破裂；平衡壓洗鼻器能夠將鼻腔內部壓力控制在較低水平，具有更小的使用風險。',
          icon: 'safety'
        },
        {
          title: '舒適',
          description: '正壓洗鼻器使用時有明顯的刺痛感，且容易嗆水。負壓洗鼻器在使用開始時會有強烈的衝擊水流，使鼻腔內產生難忍的疼痛感。',
          icon: 'comfort'
        },
        {
          title: '衛生',
          description: '傳統電動洗鼻器包含複雜的管路與水泵，內部的水路在每次使用後很難清理乾淨。每次使用後的污漬會在洗鼻器內部累積，並且在潮濕的管路中滋生細菌。納舒純洗鼻器的水路簡單、透明、可拆卸。整體圓潤簡潔，且搭配透明防塵蓋。使用後的清潔簡單、徹底，避免對鼻腔的進一步感染。',
          icon: 'hygiene'
        },
        {
          title: '性價比',
          description: '創新設計®使納舒純洗鼻器擁有比傳統電動洗鼻器更舒適、潔淨的洗鼻體驗，而價格只需電動洗鼻器的三分之一。',
          icon: 'value'
        }
      ]
    },
    vortexTip: {
      title: '伸入鼻閾的漩渦洗鼻頭',
      description: '創新的螺旋紋結構設計，出水能形成漩渦，能繞過鼻甲吸到各個竇口和嗅裂區，提供更全面的鼻腔清潔。',
      features: {
        spiral: {
          title: '螺旋紋結構',
          description: '洗鼻頭採用螺旋紋結構設計，出水時能形成漩渦水流。通過流體力學仿真找到最優螺紋結構'
        },
        deepClean: {
          title: '深度清潔',
          description1: '漩渦水流能夠繞過鼻甲結構，到達鼻腔深處，到達各個竇口，有效清潔普通洗鼻器難以觸及的區域。',
          description2: '嗅裂區氣流較慢，容易沉積顆粒物，而普通洗鼻器不容易清洗到。漩渦洗鼻頭能有效清潔這一區域。'
        },
        precision: {
          title: '精密加工',
          description: '精密模具加工，確保每個螺紋的尺寸和角度都符合設計要求，保證水流能夠形成目標形態漩渦。採用二次硫化工藝，確保矽膠材質的耐高溫、耐腐蝕、耐老化。'
        },
        comfort: {
          title: '舒適性高',
          description: '水流分散降低衝擊刺痛感，減少鼻粘膜損傷。'
        }
      }
    },
    design: {
      title: '產品設計理念',
      description1: '我們相信，好的產品設計應該回歸本質。納舒純™洗鼻器採用醫用級材質，透明設計讓您清楚看到每個細節，一體成型工藝確保無縫隙、易清潔。',
      description2: '簡單，但不簡單。每一個細節都經過精心設計，只為給您最純粹的鼻腔呵護體驗。'
    },
    testimonials: {
      title: '來自消費者的評價',
      description: '購買客戶普遍認為體驗特別好、做工優良，並且願意推薦給身邊的患者朋友使用'
    },
    technology: {
      balancedPressure: {
        title: '平衡壓力技術'
      }
    },
    images: {
      product: {
        main: '主要產品',
        design: '產品設計',
        detail: '產品細節',
        usage: '使用方式',
        showcase: '產品展示',
        tip: '洗鼻頭'
      },
      testimonials: {
        title: '客戶評價',
        description: '真實用戶分享使用心得，見證納舒純洗鼻器的卓越效果',
        comment1: '客戶評價1',
        comment2: '客戶評價2',
        comment3: '客戶評價3',
        comment4: '客戶評價4'
      }
    }
  },

  // 適用症狀
  symptoms: {
    title: '適用症狀',
    subtitle: '納舒純™洗鼻器，為各種鼻腔問題提供專業解決方案',
    commonProblems: {
      title: '常見鼻腔問題',
      description: '科學洗鼻，有效緩解多種鼻腔不適，讓您重獲暢快呼吸',
      items: {
        nasalCongestion: {
          title: '鼻塞',
          description: '鼻腔阻塞，呼吸不暢'
        },
        postNasalDrip: {
          title: '鼻涕倒流',
          description: '鼻涕向後流入喉嚨'
        },
        turbinateHypertrophy: {
          title: '鼻甲肥大',
          description: '鼻甲組織增生腫大'
        },
        deviatedSeptum: {
          title: '鼻中隔彎曲',
          description: '鼻中隔偏離中線'
        },
        postSurgicalCare: {
          title: '術後護理',
          description: '鼻腔手術後恢復護理'
        },
        dryRhinitis: {
          title: '乾燥性鼻炎',
          description: '鼻腔黏膜乾燥發炎'
        },
        vasomotorRhinitis: {
          title: '血管運動性鼻炎',
          description: '非過敏性鼻炎，由血管神經功能失調引起'
        },
        infectiousRhinitis: {
          title: '感染性鼻炎',
          description: '細菌或病毒感染引起'
        },
        eyeNoseAllergy: {
          title: '眼鼻過敏',
          description: '過敏性鼻炎伴隨眼部症狀'
        },
        nasalCough: {
          title: '鼻源性咳嗽',
          description: '鼻涕刺激引起的咳嗽'
        },
        sleepApnea: {
          title: '睡眠呼吸暫停',
          description: '睡眠時呼吸中斷'
        },
        occupationalRhinitis: {
          title: '職業性鼻炎',
          description: '工作環境引起的鼻炎'
        }
      }
    }
    ,
    // SymptomsPage 單列展示用
    flu: {
      title: '流感與感冒',
      description: '溫和沖洗，快速清除鼻腔分泌物，有效緩解感冒鼻塞症狀'
    },
    covid: {
      title: '新冠防護輔助',
      description: '科學洗鼻，減少鼻腔病毒載量，作為日常防護的重要輔助手段'
    },
    rhinitis: {
      title: '各種類型鼻炎',
      description: '定期清潔護理，有效減少過敏原刺激，改善鼻炎症狀'
    },
    smog: {
      title: '空氣污染防護',
      description: '深度清潔鼻腔，有效清除PM2.5等有害物質，保護呼吸道健康'
    }
  },

  // 購物指南
  shoppingGuide: {
    title: '購物指南',
    subtitle: '貼心購物服務，讓您的每一次購買都安心滿意',
    alerts: {
      importantReminder: '重要提醒',
      freeShipping: '滿額免運優惠',
      notes: '注意事項',
      returnConditions: '退換貨條件',
      refundTime: '退款時間',
      serviceHours: '客服時間'
    },
    returns: {
      title: '退換貨保障',
      description: '7天無憂退換，讓您購買更安心（人為損壞及已開封耗材除外）'
      ,
      appreciationPeriod: {
        title: '7天鑑賞期',
        description: '收到商品後7天內可申請退換貨，為您提供充分的考慮時間',
        conditions: '商品需保持完整包裝及配件，無明顯人為損壞痕跡'
      },
      returnProcess: {
        title: '簡便退換流程',
        steps: [
          '聯繫客服提出退換申請',
          '客服確認並指導退貨流程',
          '按指引寄回商品',
          '驗收後快速處理退款'
        ],
        refundTime: '商品驗收合格後，3-7個工作天內完成退款處理'
      }
    },
    packageTracking: {
      title: '包裹查詢',
      description: '出貨後您可透過物流單號追蹤包裹進度',
      queryMethods: {
        title: '查詢方式',
        homeDelivery: {
          title: '宅配包裹',
          description: '請至「新竹物流」輸入貨號查詢',
          button: '查詢宅配'
        },
        convenienceStore: {
          title: '超商包裹',
          description: '請至「7-11網站」、「全家網站」輸入單號查詢',
          sevenEleven: '7-11查詢',
          familyMart: '全家查詢'
        }
      },
      pickupNotes: {
        title: '取貨注意事項',
        homeDelivery: '如包裹配送時不在府，物流人員會與您聯繫後續配送事宜',
        convenienceStore: '請於商品到店後 7 天內 至指定超商門市出示同名證件取貨',
        importantNote: '若逾時未取件而致逆物流及二次寄送費用產生，需自行負擔相關作業成本，日後將無法使用該方式消費。'
      }
    },
    contact: {
      title: '聯絡我們',
      serviceEmail: {
        title: '客服信箱',
        address: 'service@ventosano.com'
      },
      servicePhone: {
        title: '客服電話',
        number: '(02) 7730-8767'
      },
      lineService: {
        title: 'LINE 客服',
        id: '@ventosano'
      },
      serviceHours: '週一至週五 09:30-18:00（國定假日休息）'
    },
    // 扁平別名：供頁面直接取用特定付款方式
    paymentMethods: {
      title: '付款方式',
      description: '貨到付款，安全便捷',
      importantNote: '所有訂單均採用貨到付款方式',
      cod: {
        title: '貨到付款',
        description: '宅配到府時現金付款',
        note: '送貨員將在送達時收取款項'
      },
      cashOnDelivery: {
        title: '貨到付款',
        description: '宅配到府時現金付款',
        note: '送貨員將在送達時收取款項'
      },
      creditCard: {
        title: '信用卡付款',
        description: '支援 Visa、MasterCard、JCB 等主要卡種',
        note: '部分銀行可能不支援分期付款/海外卡；以授權結果為準'
      },
      mobilePayment: {
        title: '行動支付',
        description: '支援 Apple Pay、Google Pay 和多種電子錢包',
        note: '實際支援的錢包以結帳模態顯示為準'
      },
      convenienceStore: {
        title: '超商付款',
        description: '支援 7-11、全家、萊爾富條碼/代碼付款',
        note: '付款條碼/代碼有效期及手續費依超商規定為準'
      }
    },
    // 扁平別名：配送與運費說明
    shipping: {
      title: '配送方式',
      description: '快速安全的配送服務',
      deliveryTypes: {
        homeDelivery: '宅配到府',
        convenienceStore: '超商取貨'
      },
      shippingFees: {
        title: '運費說明',
        homeDelivery: {
          title: '宅配到府運費',
          description: '單筆訂單未滿免運門檻，酌收運費；特價活動以頁面公告為準'
          ,
          mainIsland: '本島',
          outlyingIslands: '外島'
        },
        convenienceStore: {
          title: '超商取貨運費',
          mainIsland: '本島',
          outlyingIslands: '外島'
        },
        freeShipping: '滿額即享免運，門檻依活動公告為準',
        convenienceStorePickup: {
          title: '超商取貨運費',
          description: '超商取貨統一運費；滿額或特定活動可享免運'
        },
        storePickup: {
          title: '門市自取',
          description: '門市自取免運，請依營業時間前往取貨'
        }
      }
      ,
      shippingTime: {
        title: '配送時間',
        description: '現貨訂單24小時內出貨，宅配約1-2個工作天；偏遠地區/節假日順延',
        sameDay: '中午前成立且完成付款之訂單，當日出貨',
        nextDay: '正常情況下次一工作天配送',
        homeDelivery: '宅配：本島1-2個工作天，外島2-4個工作天',
        convenienceStore: '超商：到店通知後3日內取貨',
        remoteAreas: '偏遠/山區物流時效將順延',
        notes: [
          '實際到貨時間依物流配送為準',
          '遇天災/節日大檔可能延誤',
          '跨島及偏遠地區運期較長'
        ]
      }
    },
    sections: {
      payment: {
        title: '付款方式',
        description: '我們提供多種安全便捷的付款方式',
        methods: [
          {
            title: '信用卡付款',
            description: '支援Visa、MasterCard、JCB等主要信用卡',
            icon: 'credit-card'
          },
          {
            title: '銀行轉帳',
            description: 'ATM轉帳或網路銀行轉帳',
            icon: 'bank'
          },
          {
            title: '貨到付款',
            description: '宅配到府時現金付款',
            icon: 'truck'
          }
        ]
      },
      shipping: {
        title: '配送方式',
        description: '快速安全的配送服務',
        methods: [
          {
            title: '宅配到府',
            description: '24小時內出貨，1-2個工作天送達',
            icon: 'home'
          },
          {
            title: '超商取貨',
            description: '7-11、全家、萊爾富等超商取貨',
            icon: 'shop'
          },
          {
            title: '門市自取',
            description: '台北門市現場取貨',
            icon: 'store'
          }
        ]
      },
      return: {
        title: '退換貨政策',
        description: '7天鑑賞期，無條件退換貨',
        conditions: [
          '收到商品後7天內可申請退換貨',
          '商品需保持完整包裝及配件',
          '非人為損壞可全額退款',
          '運費由我們承擔'
        ]
      }
    }
  },

  // 洗鼻鹽指南
  salineGuide: {
    title: '洗鼻鹽指南',
    subtitle: '選擇合適的洗鼻鹽，讓洗鼻效果更佳',
    types: {
      title: '洗鼻鹽種類',
      description: '不同類型的洗鼻鹽適用於不同需求',
      items: [
        {
          title: '生理鹽水',
          description: '0.9%濃度，最接近人體體液，溫和舒適',
          concentration: '0.9%',
          features: ['溫和舒適', '適合日常使用', '無刺激性']
        },
        {
          title: '高滲鹽水',
          description: '濃度較高，清潔效果更強，適合嚴重鼻塞',
          concentration: '1.2-2.0%',
          features: ['清潔效果強', '適合嚴重鼻塞', '短期使用']
        },
        {
          title: '低滲鹽水',
          description: '濃度較低，溫和滋潤，適合乾燥性鼻炎',
          concentration: '0.5-0.7%',
          features: ['溫和滋潤', '適合乾燥性鼻炎', '長期使用']
        }
      ]
    },
    preparation: {
      title: '配製方法',
      description: '正確的配製方法確保洗鼻效果',
      steps: [
        '準備500ml溫開水（35-37°C）',
        '加入4.5g洗鼻鹽（約1茶匙）',
        '充分攪拌至完全溶解',
        '測試溫度，確保接近體溫'
      ]
    },
    usage: {
      title: '使用注意事項',
      description: '正確使用洗鼻鹽，確保安全有效',
      tips: [
        '使用專用洗鼻鹽，避免使用普通食鹽',
        '配製後24小時內使用完畢',
        '如有不適，立即停止使用',
        '定期清潔洗鼻器'
      ]
    }
  },

  // 客服中心
  customerService: {
    title: '客服中心',
    myConversations: '我的對話',
    createConversation: '新建對話',
    conversationTitle: '對話標題',
    conversationType: '問題類型',
    conversationDescription: '問題描述',
    submit: '提交',
    cancel: '取消',
    status: {
      OPEN: '進行中',
      PENDING: '等待中',
      CLOSED: '已關閉'
    },
    types: {
      PRODUCT: '產品問題',
      ORDER: '訂單問題',
      TECHNICAL: '技術問題',
      OTHER: '其他問題'
    },
    timeFormat: {
      justNow: '剛剛',
      minutesAgo: '分鐘前',
      hoursAgo: '小時前',
      daysAgo: '天前'
    },
    messages: {
      loadFailed: '加載對話列表失敗',
      loadMessagesFailed: '加載消息失敗',
      createSuccess: '對話創建成功',
      createFailed: '創建對話失敗',
      sendFailed: '發送消息失敗',
      typeMessage: '輸入消息...',
      send: '發送'
    },
    chatWidget: {
      title: '客服諮詢',
      expand: '展開',
      minimize: '最小化',
      noMessages: '暫無消息，開始對話吧！',
      userAvatar: '我',
      staffAvatar: '客',
      inputPlaceholder: '輸入消息...'
    }
  },
  payment: {
    title: '選擇支付方式',
    selectMethod: '請選擇支付方式',
    methods: {
      linepay: 'Line Pay',
      creditcard: '信用卡',
      mobile: '行動支付'
    },
    processing: '處理中...',
    success: '支付成功！',
    error: '支付失敗，請重試',
    security: '支付過程安全加密，我們不會儲存您的支付信息'
  },

  // 隐私政策
  privacyPolicy: {
    title: '隱私政策',
    lastUpdated: '最後更新：2024年10月6日 | 生效日期：2024年10月6日',
    downloadPDF: '下載PDF版本',
    back: '返回',
    
    sections: {
      overview: {
        title: '1. 概述',
        content: '本隱私政策說明了柔性負壓洗鼻器（"我們"、"我們的"或"公司"）如何收集、使用、存儲和保護您的個人信息。我們致力於保護您的隱私權，並遵守適用的數據保護法律，包括歐盟通用數據保護條例（GDPR）、加州消費者隱私法案（CCPA）和英國通用數據保護條例（UK-GDPR）。'
      },
      
      informationCollection: {
        title: '2. 我們收集的信息',
        directlyProvided: {
          title: '2.1 您直接提供的信息',
          items: [
            '賬戶信息：姓名、電子郵件地址、電話號碼、密碼',
            '訂單信息：收貨地址、支付信息、訂單歷史',
            '通信信息：您與我們客服的通信記錄',
            '偏好設置：語言偏好、通知設置'
          ]
        },
        automaticallyCollected: {
          title: '2.2 自動收集的信息',
          items: [
            '設備信息：IP地址、瀏覽器類型、操作系統',
            '使用數據：頁面訪問記錄、點擊行為、停留時間',
            'Cookie和類似技術：用於改善用戶體驗和網站功能'
          ]
        }
      },
      
      informationUsage: {
        title: '3. 信息使用目的',
        content: '我們使用收集的信息用於以下目的：',
        purposes: [
          '提供、維護和改進我們的服務',
          '處理訂單和支付',
          '客戶服務和支持',
          '發送重要通知和更新',
          '個性化用戶體驗',
          '法律合規和風險管理',
          '營銷和推廣（在您同意的情況下）'
        ]
      },
      
      legalBasis: {
        title: '4. 數據處理的法律依據（GDPR/UK-GDPR）',
        items: [
          '同意：您明確同意我們處理您的個人數據',
          '合同履行：為履行與您的合同而必需',
          '法律義務：遵守適用的法律要求',
          '合法利益：我們的合法商業利益（如安全、欺詐預防）'
        ]
      },
      
      informationSharing: {
        title: '5. 信息共享',
        content: '我們不會出售您的個人信息。我們可能在以下情況下共享信息：',
        scenarios: [
          '服務提供商：幫助我們運營業務的第三方（如支付處理商、物流公司）',
          '法律要求：遵守法律義務或響應法律程序',
          '業務轉讓：在合併、收購或資產出售時',
          '同意：在您明確同意的情況下'
        ]
      },
      
      dataSecurity: {
        title: '6. 數據安全',
        content: '我們採用行業標準的安全措施來保護您的個人信息，包括：',
        measures: [
          'SSL/TLS加密傳輸',
          '安全的數據存儲',
          '訪問控制和權限管理',
          '定期安全審計',
          '員工數據保護培訓'
        ]
      },
      
      dataRetention: {
        title: '7. 數據保留',
        content: '我們僅在實現收集目的所需的時間內保留您的個人信息。具體保留期限如下：',
        periods: [
          '賬戶信息：賬戶活躍期間 + 3年',
          '訂單記錄：7年（稅務和法律要求）',
          '營銷數據：直到您撤回同意',
          '網站日誌：12個月'
        ]
      },
      
      yourRights: {
        title: '8. 您的權利',
        gdpr: {
          title: '8.1 GDPR/UK-GDPR權利',
          rights: [
            '訪問權：獲取我們持有的關於您的個人數據副本',
            '更正權：要求更正不準確的個人數據',
            '刪除權：要求刪除您的個人數據（"被遺忘權"）',
            '限制處理權：限制我們處理您個人數據的方式',
            '數據可攜權：以結構化、常用格式獲取您的數據',
            '反對權：反對基於合法利益的數據處理',
            '撤回同意：隨時撤回您給予的同意'
          ]
        },
        ccpa: {
          title: '8.2 CCPA權利（加州居民）',
          rights: [
            '知情權：了解我們收集的個人信息類別',
            '訪問權：獲取我們收集的關於您的個人信息',
            '刪除權：要求刪除您的個人信息',
            '選擇退出權：選擇不出售您的個人信息',
            '非歧視權：行使權利時不受歧視'
          ]
        }
      },
      
      cookies: {
        title: '9. Cookie和跟踪技術',
        content: '我們使用Cookie和類似技術來改善您的網站體驗。您可以通過瀏覽器設置管理Cookie偏好。',
        types: [
          '必要Cookie：網站基本功能所必需',
          '功能Cookie：記住您的偏好設置',
          '分析Cookie：幫助我們了解網站使用情況',
          '營銷Cookie：提供個性化廣告（需同意）'
        ]
      },
      
      internationalTransfer: {
        title: '10. 國際數據傳輸',
        content: '您的個人信息可能被傳輸到您所在國家/地區以外的地方進行處理。我們確保此類傳輸符合適用的數據保護法律，並採取適當的安全措施。'
      },
      
      childrenPrivacy: {
        title: '11. 兒童隱私',
        content: '我們的服務不面向13歲以下的兒童。我們不會故意收集13歲以下兒童的個人信息。如果我們發現收集了此類信息，將立即刪除。'
      },
      
      policyUpdates: {
        title: '12. 隱私政策更新',
        content: '我們可能會不時更新本隱私政策。重大變更將通過電子郵件或網站通知您。我們建議您定期查看本政策以了解最新信息。'
      },
      
      contactUs: {
        title: '13. 聯繫我們',
        content: '如果您對本隱私政策有任何疑問或希望行使您的權利，請通過以下方式聯繫我們：',
        contactInfo: [
          '電子郵件：privacy@nasal-irrigator.com',
          '電話：+886-2-1234-5678',
          '地址：台灣台北市信義區信義路五段7號'
        ],
        dpo: '數據保護官（DPO）：如果您是歐盟或英國居民，您也可以聯繫我們的數據保護官：dpo@nasal-irrigator.com'
      },
      
      regulatoryComplaints: {
        title: '14. 監管機構投訴',
        content: '如果您認為我們違反了數據保護法律，您有權向相關監管機構投訴：',
        authorities: [
          '歐盟：您所在成員國的數據保護機構',
          '英國：信息專員辦公室（ICO）',
          '加州：加州總檢察長辦公室'
        ]
      },
      
      footer: {
        content: '本隱私政策構成我們與您之間關於個人信息處理的完整協議。通過使用我們的服務，您同意本隱私政策的條款。'
      }
    }
  },

  // 销户页面
  deleteAccount: {
    title: '銷戶申請',
    subtitle: '請確認您要刪除您的賬戶，此操作不可逆',
    
    steps: {
      enterEmail: '輸入郵箱',
      verifyCode: '驗證碼驗證',
      confirm: '確認銷戶'
    },
    
    warning: {
      title: '重要提醒',
      description: '銷戶後將無法恢復您的賬戶數據，包括訂單記錄、優惠券、個人信息等。請謹慎操作。'
    },
    
    email: {
      label: '郵箱地址',
      placeholder: '請輸入您的註冊郵箱',
      required: '請輸入郵箱地址',
      invalid: '請輸入有效的郵箱地址'
    },
    
    verification: {
      label: '驗證碼',
      placeholder: '請輸入4位驗證碼',
      required: '請輸入驗證碼',
      length: '驗證碼必須為4位數字',
      sent: '驗證碼已發送，請檢查您的郵箱',
      resent: '驗證碼已重新發送',
      sendFailed: '發送驗證碼失敗',
      cooldown: '請等待1分鐘後再重新發送',
      maxAttempts: '已達到最大發送次數，請稍後再試'
    },
    
    sendVerification: '發送驗證碼',
    resendVerification: '重新發送驗證碼',
    confirmDelete: '確認銷戶',
    backToEmail: '返回修改郵箱',
    
    delete: {
      success: '賬戶已成功刪除',
      failed: '銷戶失敗，請重試'
    },
    
    footer: {
      note: '如有疑問，請聯繫客服'
    }
  },

  // 商品目录页
  productCatalog: {
    title: '台灣商品目錄',
    subtitle: '展示所有台灣地區的優質商品',
    searchPlaceholder: '搜尋產品...',
    selectCategory: '選擇分類',
    priceRange: '價格範圍',
    sortBy: '排序方式',
    resetFilters: '重置篩選',
    view: '查看',
    addToCart: '加購',
    added: '已添加',
    inStock: '有庫存',
    outOfStock: '缺貨',
    stock: '庫存',
    noProductsFound: '沒有找到相關產品',
    priceRanges: {
      range1: 'NT$0 - NT$100',
      range2: 'NT$100 - NT$300',
      range3: 'NT$300 - NT$500',
      range4: 'NT$500 - NT$1000',
      range5: 'NT$1000+'
    },
    sortOptions: {
      nameAsc: '名稱 A-Z',
      nameDesc: '名稱 Z-A',
      priceAsc: '價格 低到高',
      priceDesc: '價格 高到低',
      newest: '最新上架'
    },
    pagination: {
      showTotal: '第 {start}-{end} 條，共 {total} 條'
    },
    messages: {
      loadFailed: '加載產品失敗',
      insufficientStock: '商品庫存不足',
      addedToCart: '商品已添加到購物車',
      viewProduct: '查看商品: {name}'
    }
  },

  // 商品详情页
  productDetail: {
    loading: '載入中...',
    notFound: '商品不存在',
    backToHome: '返回首頁',
    breadcrumb: {
      home: '首頁',
      products: '商品列表'
    },
    images: {
      noImage: '暫無圖片'
    },
    info: {
      rating: '評價',
      reviews: '評價',
      limitedOffer: '限時優惠',
      features: {
        authentic: '正品保證',
        fastDelivery: '快速配送',
        returnPolicy: '7天無理由退貨'
      },
      quantity: '數量:',
      addToCart: '加購',
      buyNow: '立即購買',
      favorite: '收藏',
      share: '分享'
    },
    tabs: {
      description: '商品詳情',
      specifications: '規格參數',
      reviews: '用戶評價'
    },
    specifications: {
      name: '商品名稱',
      sku: '商品編號',
      category: '分類',
      status: '狀態',
      inStock: '在售',
      outOfStock: '下架',
      noDescription: '暫無商品描述'
    },
    reviews: {
      stats: {
        averageRating: '平均評分',
        totalReviews: '評價總數',
        ratingDistribution: '評分分佈',
        stars: '星',
        reviews: '條'
      },
      actions: {
        writeReview: '寫評價',
        loginFirst: '請先登入',
        alreadyReviewed: '您已評價過該商品'
      },
      list: {
        anonymousUser: '匿名用戶',
        verifiedPurchase: '驗證購買',
        helpful: '有用',
        thankYou: '感謝您的反饋'
      },
      modal: {
        title: '寫評價',
        rating: '評分',
        ratingRequired: '請選擇評分',
        titleLabel: '評價標題',
        titlePlaceholder: '給您的評價起個標題（可選）',
        content: '評價內容',
        contentPlaceholder: '分享您的使用體驗...',
        anonymous: '匿名評價',
        submit: '提交評價',
        cancel: '取消'
      },
      messages: {
        submitSuccess: '評價提交成功，等待審核',
        submitFailed: '評價提交失敗',
        fetchFailed: '獲取評價數據失敗',
        loginRequired: '請先登入'
      }
    },
    messages: {
      productNotFound: '商品不存在',
      fetchFailed: '獲取商品詳情失敗',
      loginRequired: '請先登入',
      addToCartSuccess: '已將 {name} 添加到購物車',
      addToCartTrigger: '觸發打開購物車事件'
    }
  }
};
